import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../../http";
import type { Token } from "@/lib/types/secure-llm";

async function getMyTokens() {
  return await api.governance.get<Array<Token>>("my-tokens");
}

export const myTokensQueryOptions = queryOptions({
  queryKey: ["secure-llm", "my-tokens"],
  async queryFn() {
    const res = await getMyTokens();
    const data = await res.json();
    return { res, data };
  },
  select(data) {
    return data.data;
  },
});

export function useMyTokens() {
  return useQuery(myTokensQueryOptions);
}
